/** Returns a flat array with all of this element's children {@link RgObject} and their children, recursively */
function deepFlatChildren(obj) {
    const result = [];
    result.push(...obj.children);
    obj.children.forEach(c => result.push(...deepFlatChildren(c)));
    return result;
}

export { deepFlatChildren };
//# sourceMappingURL=deep-flat-children.js.map
